import { render, staticRenderFns } from "./EditNoticeByNoticeNo.vue?vue&type=template&id=3322f154&scoped=true&"
import script from "./EditNoticeByNoticeNo.vue?vue&type=script&lang=ts&"
export * from "./EditNoticeByNoticeNo.vue?vue&type=script&lang=ts&"
import style0 from "./EditNoticeByNoticeNo.vue?vue&type=style&index=0&id=3322f154&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3322f154",
  null
  
)

export default component.exports